module.exports = __webpack_public_path__ + "img/merch-banner.0d832557.jpg";